// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ak8qxyUsnV4SBGBRDYbk {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
  font-size: 20px;
  font-weight: bold;
}

.Md8RynAwNuyLyz3D9tXj {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  font-size: 16px;
}

.PqLALfxLMp1Gb7iD_8eI {
  margin: 0.67em 0;
  width: 72px;
  height: 72px;
}

.kpMtYKgzD8mnZbPKeg_R {
  display: inline-block;
  width: 100%;
}

.kpMtYKgzD8mnZbPKeg_R .Vi_MOJnOTxv3esxZKNZX {
  color: #dfe2f2;
  background-color: #dfe2f2;
  width: 5px;
  height: 5px;
  margin: 5px;
}

.kpMtYKgzD8mnZbPKeg_R .Vi_MOJnOTxv3esxZKNZX.RKaoGEzuofZhN0vdFfOh {
  color: #acb7d4;
  background-color: #acb7d4;
  width: 5px;
  height: 5px;
  margin: 5px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .xOMcN_4CWuxIyRxzPY1s {
    margin-top: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Slider/Slider.module.css"],"names":[],"mappings":"AAMA;EACE,mDAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mDAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-text-subtle from colors;\n\n.headerSlideTitle {\n  color: color-text;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.headerSlideDescription {\n  color: color-text-subtle;\n  font-size: 16px;\n}\n\n.imageSlider {\n  margin: 0.67em 0;\n  width: 72px;\n  height: 72px;\n}\n\n.buttonSlider {\n  display: inline-block;\n  width: 100%;\n}\n\n.buttonSlider .checkboxSlider {\n  color: #dfe2f2;\n  background-color: #dfe2f2;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n.buttonSlider .checkboxSlider.checked {\n  color: #acb7d4;\n  background-color: #acb7d4;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n@media screen and (max-width: tablet-l) {\n  .sliderContainer {\n    margin-top: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"headerSlideTitle": `ak8qxyUsnV4SBGBRDYbk`,
	"headerSlideDescription": `Md8RynAwNuyLyz3D9tXj`,
	"imageSlider": `PqLALfxLMp1Gb7iD_8eI`,
	"buttonSlider": `kpMtYKgzD8mnZbPKeg_R`,
	"checkboxSlider": `Vi_MOJnOTxv3esxZKNZX`,
	"checked": `RKaoGEzuofZhN0vdFfOh`,
	"sliderContainer": `xOMcN_4CWuxIyRxzPY1s`
};
export default ___CSS_LOADER_EXPORT___;
